/*
 *  I04CALCULGDETAI18n.js
 *
 *  Created by Sébastien Hecart on 2019-05-14 15:38:26 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */

export default {
  I04CALCULGDETA_SECTION_0_TITLE: 'Bâtiment',
  I04CALCULGDETA_in_surface: 'Surface',
  I04CALCULGDETA_in_hspm: 'HSPmoyenne',
  I04CALCULGDETA_res_volume: 'Volume',
  I04CALCULGDETA_SECTION_1_TITLE: 'Façade(s)',
  I04CALCULGDETA_in_nb_facade: 'Nombre de façade(s)',
  I04CALCULGDETA_SECTION_2_TITLE: 'Plafond(s)',
  I04CALCULGDETA_in_nb_plafond: 'Nombre de plafond(s)',
  I04CALCULGDETA_SECTION_3_TITLE: 'Plancher(s)',
  I04CALCULGDETA_in_nb_plancher: 'Nombre de plancher(s)',
  I04CALCULGDETA_SECTION_4_TITLE: 'Vitrage(s)',
  I04CALCULGDETA_in_nb_vitrage: 'Nombre de vitrage(s)',
  I04CALCULGDETA_SECTION_5_TITLE: 'Porte(s)',
  I04CALCULGDETA_in_nb_porte: 'Nombre de porte(s)',
  I04CALCULGDETA_SECTION_6_TITLE: 'Ventilation',
  I04CALCULGDETA_ventilation_uuid: '',
  I04CALCULGDETA_in_ventil_lambda: "Taux de renouvelement d'air",
  I04CALCULGDETA_SECTION_7_TITLE: '',
  I04CALCULGDETA_res_coeffG: 'Coefficient de déperditions volumiques',
  I04CALCULGDETA_SECTION_8_TITLE: 'Pont(s) thermique(s)',
  //now really good but I don't care
  I04CALCULGDETA_color_facades: '#4285f4',
  I04CALCULGDETA_color_pont: '#A8E1D5',
  I04CALCULGDETA_color_plafonds: '#db4437',
  I04CALCULGDETA_color_planchers: '#f4b400',
  I04CALCULGDETA_color_portes: '#54A9D5',
  I04CALCULGDETA_color_vitrages: '#68D68F', //'##0f9d58',my color is better
  I04CALCULGDETA_color_ventilation: '#ab30c4',
  I04CALCULGDETA_mail_facades: 'Description détaillée des facades',
  I04CALCULGDETA_mail_plafonds: 'Description détaillée des plafonds',
  I04CALCULGDETA_mail_planchers: 'Description détaillée des planchers',
  I04CALCULGDETA_mail_portes: 'Description détaillée des portes',
  I04CALCULGDETA_mail_vitrages: 'Description détaillée des vitrages',
  I04CALCULGDETA_mail_ventilation: 'Description détaillée de la ventilation',
  I04CALCULGDETA_mail_Nature: 'Nature'
}
